import React, {useState, useEffect} from "react";

export default function ClassicoJackeFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);
  const [darkenColorContrast, setDarkenColorContrast] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -60));
    setDarkenColorContrast(adjust(darkContrast, -100));
  }, [lightContrast, darkContrast]);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M452.093,447.098c-0.211-3.209-3.39-51.2-6.281-62.75c-3.019-12.07-6.989-40.919-7.989-51.95
		c-1.011-11.15-14.011-85.059-17.03-92.09c-1.231-2.879-5.59-18.74-10.63-37.1c-7.06-25.699-15.84-57.68-19.37-65.9
		c-4.09-9.57-9.67-18.33-12.67-23.04c-1.16-1.83-2-3.15-2.25-3.7c-0.11-0.26-0.26-0.46-0.451-0.6c-1.12-0.84-5.339-4-6.469-4.82
		c-7.061-5.16-14.09-9.38-21.49-12.91c-7.581-3.62-15.52-6.55-23.61-8.729c-6.44-1.731-12.961-3.241-19.4-4.5
		c-0.54-0.111-0.94-0.191-1.281-0.261c-0.729-0.15-1.239-0.25-2.299-0.42l0.13-0.33c0.71-1.75,0.04-3.55-0.55-5.13
		c-0.09-0.229-0.17-0.46-0.26-0.689l-8.66-20.861c-1.361-3.26-4.09-5.639-7.3-6.35c-4.61-1.01-9.55-1.209-14.341-1.4
		c-1.109-0.04-2.209-0.09-3.289-0.139c-6.1-0.301-12.291-0.431-18.381-0.361c-8.509,0.08-17.299,0.17-26.019,1.45
		c-0.83,0.121-1.66,0.25-2.481,0.38l-0.91,0.14c-1.899,0.301-3.609,1.31-4.84,2.88l-13.059,24.9c-1.06,1.35-1.38,3.09-0.91,4.7
		c-4.72,1.121-11.111,2.8-17.27,4.53c-5.75,1.62-11.55,3.39-17.24,5.26l-0.3,0.1c-5.271,1.74-10.721,3.53-15.771,6.06
		c-11.489,5.74-23.379,15.6-23.379,16.95c-0.05,0.31-1.09,1.95-2.3,3.85c-3,4.71-8.58,13.47-12.681,23.04
		c-3.519,8.22-12.309,40.201-19.359,65.9c-5.05,18.36-9.401,34.221-10.641,37.1c-3.01,7.031-16.01,80.94-17.019,92.09
		c-1,11.031-4.97,39.88-7.991,51.95c-1.679,6.7-3.449,25.661-4.689,41.03v0.011c-0.891,11.12-1.5,20.359-1.59,21.709
		c-0.131,0.11-0.221,0.27-0.23,0.46c-0.02,0.31,0.15,0.581,0.42,0.67c18.65,6.44,31.38,8.17,39.66,8.17c4.24,0,7.31-0.46,9.42-0.96
		c0.599-0.14,1.019-0.67,1.12-1.34h0.02c0.129-0.66,12.379-66.69,15.06-74.169c2.26-6.321,17.399-62.201,19.35-72.941
		c1.549-8.54,6.59-33.09,11.789-47.76c0.061,13.111,0.601,71.39,0.611,72.02l0.889,74.31c-0.009,0.13-1.639,13.49-1.49,20.49
		c0.101,4.41,6.17,8,11.25,10.23c3.5,1.54,7.25,2.54,11.141,2.97l66.99,7.37c0.13,0.01,2.94,0.34,4.66,0.34
		c0.119,0,0.24,0,0.35-0.01c1.16,0.51,6.359,0.86,11.75,0.86c4.55,0,9.22-0.25,11.7-0.87l0.13-0.03l0.07-0.12
		c0.02-0.04,0.039-0.09,0.06-0.14c1.179-0.08,4.809-0.759,4.95-0.78l32.71-3.52c2.88-0.31,5.84-0.57,8.7-0.83
		c7.539-0.67,15.34-1.36,22.85-3.009c0.469-0.111,1-0.221,1.58-0.341c6.99-1.48,20.01-4.22,20.189-12.12
		c0.111-5.02-0.689-13.209-1.17-17.65c-0.219-2-0.359-4.05-0.41-6.09l1.591-72.23v-73.64c3.5,10.03,7.659,27.83,11.79,50.55
		c1.949,10.74,17.08,66.62,19.35,72.941c1.724,4.829,7.446,34.068,11.319,54.359l-0.083-0.141l-0.152,0.092l0.236,0.383l0.056-0.033
		c2.096,10.984,3.638,19.277,3.684,19.509h0.02c0.099,0.67,0.519,1.2,1.12,1.34c2.11,0.5,5.18,0.96,9.42,0.96
		c8.28,0,21.01-1.73,39.66-8.17c0.269-0.089,0.44-0.36,0.42-0.67C452.312,447.368,452.222,447.208,452.093,447.098z"
        />
        <path
          fill="#F0EFEF"
          d="M364.327,162.997c-0.07,0.46-0.141,0.931-0.21,1.4c-3.36-0.58-49.14-8.21-99.72-6.379l-0.041-1.451
		C314.307,154.747,359.997,162.259,364.327,162.997"
        />
        <path
          fill="#F0EFEF"
          d="M238.096,158.047c-50.21-1.869-96.51,5.631-100.789,6.341c-0.07-0.481-0.141-0.96-0.201-1.441
		c3.78-0.639,50.5-8.24,100.951-6.349C238.067,157.077,238.086,157.558,238.096,158.047"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M261.057,92.268c-0.281-0.021-0.561-0.03-0.9-0.03c-1.29-0.04-2.571-0.09-3.861-0.14
		c-0.58-0.03-1.17-0.051-1.75-0.07c-0.04-0.311-0.09-1.01,0.04-1.79c0.071-0.46,0.151-0.67,0.19-0.76
		c0.041,0.019,0.06,0.05,0.1,0.06C256.666,89.858,258.796,90.868,261.057,92.268"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M249.147,91.928h-0.16c-1.771,0.029-4.26,0.149-6.461,0.35c2.35-1.46,4.56-2.491,6.391-2.781
		c0.04,0.101,0.109,0.311,0.189,0.741C249.216,90.948,249.186,91.588,249.147,91.928"
        />
        <path
          fill={darkenColor}
          d="M99.497,453.928c-0.02,0.359-0.21,0.779-0.641,0.88c-6.159,1.47-20.67,2.489-48.659-7.22
		c5.72-1.15,25.76-4.08,48.76,5.289C99.397,453.068,99.526,453.558,99.497,453.928"
        />
        <path
          fill={darkenColor}
          d="M451.657,447.598v0.02c-28.04,9.679-42.561,8.66-48.721,7.19c-0.429-0.101-0.619-0.521-0.649-0.88
		c-0.021-0.37,0.099-0.86,0.55-1.051c12.91-5.259,24.88-6.639,33.92-6.639C443.877,446.238,449.167,447.098,451.657,447.598"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M350.497,163.047l-0.57,24.181c0,0.259-0.241,0.489-0.55,0.469l-72.83-0.269c-0.17,0-0.32-0.061-0.43-0.17
		c-0.08-0.091-0.13-0.2-0.13-0.32l0.13-28.531C306.897,158.117,334.697,160.987,350.497,163.047"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M226.846,186.078c0,0.14-0.07,0.25-0.13,0.311c-0.099,0.109-0.26,0.179-0.43,0.179l-72.91,1.5
		c-0.28,0-0.53-0.2-0.54-0.46l-1.06-24.64c16.121-2.06,43.791-4.829,74.11-4.55L226.846,186.078z"
        />
        <path
          fill={darkenColor}
          d="M275.716,70.167c-2.89,5.351-14.04,13.9-21.03,18.45c-0.09,0.061-0.15,0.141-0.19,0.231l-0.05,0.029
		c-0.16,0.101-0.35,0.32-0.5,1.25c-0.139,0.79-0.1,1.49-0.06,1.881c-1.17-0.041-2.35-0.08-3.52-0.08c-0.19-0.011-0.37,0-0.559,0
		c0.029-0.401,0.059-1.061-0.061-1.801c-0.16-0.93-0.349-1.149-0.509-1.25l-0.031-0.01c-0.03-0.05-0.059-0.099-0.11-0.13
		c-6.789-4.41-17.5-12.549-20.91-18.009C230.876,70.138,246.496,67.167,275.716,70.167"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M229.776,325.648v25.71c0,0.109-0.039,0.21-0.119,0.29c-0.09,0.09-0.191,0.12-0.311,0.13
		c-30.009-0.74-50.32-1.94-60.389-3.57c-3.601-0.581-6.83-1.831-9.79-3.1c-1.3-0.561-2.09-0.9-3.531-1.75
		c-0.229-0.141-0.37-0.391-0.37-0.66v-25.03l0.09-0.08l4.431,0.78c0.069,0.02,6.729,1.47,10.219,2.03
		c0.551,0.09,1.151,0.19,1.791,0.3c7.839,1.31,22.43,3.75,57.66,4.62C229.636,325.328,229.776,325.467,229.776,325.648"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M349.327,317.667v25.03c0,0.27-0.141,0.52-0.37,0.66c-1.441,0.85-2.23,1.19-3.53,1.75
		c-2.96,1.27-6.19,2.52-9.79,3.1c-10.07,1.631-30.39,2.83-60.39,3.57c-0.09,0-0.231-0.04-0.311-0.13
		c-0.08-0.08-0.129-0.18-0.129-0.29v-25.71c0-0.18,0.15-0.32,0.33-0.33c35.219-0.87,49.82-3.309,57.66-4.62
		c0.639-0.109,1.229-0.21,1.78-0.3c3.5-0.559,10.16-2.009,10.22-2.03l4.44-0.779l-0.06-0.32L349.327,317.667z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M238.241,444.111c-44.484-4.257-65.033-6.36-72.955-8.229c-3.108-0.732-6.361-1.745-9.064-3.448
		c-2.631-1.658-6.528-3.916-8.194-6.971"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M238.819,427.481c-45.013-4.308-64.323-6.462-71.432-8.138c-3.108-0.732-6.062-1.97-8.763-3.674
		c-2.633-1.658-6.318-4.111-9.555-6.747"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M227.605,353.378v63.364c-2.607-0.258-5.216-0.506-7.825-0.754c-9.641-0.927-19.611-1.887-29.404-3.068
		c-5.911-0.711-11.854-1.6-17.665-2.642c-2.792-0.501-5.306-0.992-7.816-1.931c-2.251-0.837-4.392-1.919-6.374-3.221l-0.424-58.712"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M224.605,353.2
		v60.236c-1.514-0.145-3.027-0.29-4.541-0.433c-9.608-0.925-19.548-1.881-29.329-3.061c-5.857-0.704-11.742-1.585-17.494-2.616
		c-2.645-0.475-5.019-0.937-7.294-1.788c-1.544-0.574-3.03-1.275-4.439-2.091l-0.378-55.663"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M228.18,325.879
		l-0.245,24.188c-29.226-0.738-49.033-1.917-58.883-3.509c-3.422-0.553-6.539-1.765-9.398-2.992
		c-1.132-0.485-1.814-0.777-2.887-1.393v-20.607v-3.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M157.66,321.69
		c0.199,0.044,8.378,1.791,11.914,2.362l1.787,0.295c7.752,1.296,22.068,3.689,56.14,4.604"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M267.981,443.332c38.475-3.871,58.262-5.706,65.659-7.45c3.109-0.733,6.171-1.718,9.082-3.031c3.037-1.371,8.519-3.075,11.237-7.39
		"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M267.685,426.703c39.035-3.928,58.448-5.529,65.056-7.087c3.107-0.732,6.061-1.972,8.763-3.674
		c2.632-1.658,8.317-4.111,11.554-6.748"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M51.389,427.688
		c0,0,10.629-2.013,19.304-1.56c0,0,19.414,0.385,33.103,8.6"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M450.195,427.391c0,0-10.628-2.013-19.304-1.56c0,0-19.414,0.385-33.102,8.6"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M265.723,159.574l0.722,25.968l-0.113,257.002l0.011,0.112l-0.001-0.037c0.007,0.137,0.024,0.238,0.033,0.293
		c0.028,0.163,0.118,0.786,0.016,1.45"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M264.293,95.239
		c-0.051,2.144-0.006,4.283,0.038,6.353l0.007,0.349c0.033,1.313,0.074,6.645,0.074,8.192c0.03,1.803,0.068,3.566,0.105,5.329
		l0.052,2.511l0.225,6.864c0.067,2.772,0.135,5.551,0.209,8.322c0.072,3.07,0.152,6.14,0.233,9.216l0.26,9.554
		c0.045,1.756,0.037,1.444,0.085,3.204"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M263.029,444.674c-2.219,0.413-5.897,0.647-10.295,0.647c-5.868,0-10.494-0.405-11.228-0.696c-0.127-0.073-0.166-0.828-0.104-1.269
		l0.017-0.129c0.497-5.403,1.01-56.568,0.838-65.422c-0.074-3.982-0.309-40.299-0.559-78.748l-0.074-11.593
		c-0.262-40.764-0.532-82.916-0.697-97.894c-0.289-27.65-1.695-58.957-2.02-65.898l0.244-0.61l-0.284-0.532
		c-0.093-4.878-0.025-20.856,0.002-26.158h0.011l0.006,0.093v-1.402c0.402-0.078,0.821-0.128,1.21-0.174l0.439-0.059
		c2.041-0.252,4.181-0.381,6.924-0.415l0.363-0.011l0.989,0.001c1.785,0.009,3.619,0.081,5.395,0.15l0.454,0.016
		c1.297,0.056,2.606,0.112,3.907,0.14l0.197,0.01c0.496,0.012,0.979,0.023,1.461,0.023c0.242,0,0.485-0.003,0.725-0.009
		c0.09,0.621,0.077-0.609,0.051,0.248l-0.004,0.136"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M227.681,69.011
		c0,0,15.659-4.059,48.564-0.619"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M299.334,75.129
		l-0.936,2.2c-3.086,7.611-9.938,24.502-14.511,30.647c-0.848-0.762-1.895-1.739-3.09-2.853l-0.088-0.083
		c-5.856-5.457-14.197-13.23-21.034-16.596"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M243.967,88.448
		c-6.84,3.368-15.179,11.142-21.026,16.593c-1.278,1.191-2.358,2.194-3.215,2.964c-4.615-5.778-13.887-24.5-18.245-33.672"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M137.113,161.111c4.138-0.706,50.689-8.247,101.258-6.33"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M364.722,161.232c0,0-46.592-8.244-98.681-6.545"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M153.433,162.595l0.986,22.908c0.021,0.481,0.422,0.858,0.903,0.847l68.908-1.414c0.493-0.011,0.884-0.423,0.866-0.916
		l-0.892-25.882"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M153.535,188.388l2.317,53.16c0.039,0.907,0.871,1.647,1.856,1.652l68.696,0.381c1.053,0.006,1.88-0.749,1.849-1.687l-1.865-55.002
		"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M277.79,158.107
		l-0.118,26.725c-0.002,0.511,0.411,0.927,0.922,0.929l68.783,0.259c0.504,0.002,0.917-0.399,0.929-0.903l0.529-22.427"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M349.231,188.027l-1.28,53.916c-0.022,0.917-0.847,1.671-1.843,1.682l-68.459,0.785c-1.034,0.012-1.863-0.737-1.853-1.673
		l0.654-54.983"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
		163.454,323.588 162.552,322.245 162.331,323.367 161.351,321.909 161.112,323.128 160.145,321.69 159.91,322.893 159.014,321.559 
		158.795,322.674 157.883,321.317 157.66,322.451 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M276.986,353.378v63.364c2.607-0.258,5.216-0.506,7.825-0.754c9.641-0.927,19.611-1.887,29.404-3.068
		c5.911-0.711,11.854-1.6,17.665-2.642c2.792-0.501,5.306-0.992,7.816-1.931c2.251-0.837,4.392-1.919,6.374-3.221l0.424-58.712"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M279.986,353.2
		v60.236c1.514-0.145,3.027-0.29,4.541-0.433c9.608-0.925,19.548-1.881,29.329-3.061c5.857-0.704,11.742-1.585,17.494-2.616
		c2.645-0.475,5.019-0.937,7.294-1.788c1.544-0.574,3.03-1.275,4.439-2.091l0.378-55.663"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="
		M276.411,325.879l0.245,24.188c29.226-0.738,49.033-1.917,58.883-3.509c3.422-0.553,6.539-1.765,9.398-2.992
		c1.132-0.485,1.814-0.777,2.887-1.393v-20.607v-3.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.343,1.342"
          d="M346.931,321.69
		c-0.199,0.044-8.378,1.791-11.914,2.362l-1.787,0.295c-7.751,1.296-22.068,3.689-56.14,4.604"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
		341.138,323.588 342.04,322.245 342.26,323.367 343.24,321.909 343.479,323.128 344.446,321.69 344.682,322.893 345.577,321.559 
		345.796,322.674 346.708,321.317 346.931,322.451 	"
        />
        <path
          fill="#010101"
          d="M452.057,447.098c-0.211-3.209-3.39-51.2-6.281-62.75c-3.019-12.07-6.989-40.919-7.989-51.95
		c-1.011-11.15-14.011-85.059-17.03-92.09c-1.231-2.879-5.59-18.74-10.63-37.1c-7.06-25.699-15.84-57.68-19.37-65.9
		c-4.09-9.57-9.67-18.33-12.67-23.04c-1.16-1.83-2-3.15-2.25-3.7c-0.11-0.26-0.26-0.46-0.451-0.6c-1.12-0.84-5.339-4-6.469-4.82
		c-7.061-5.16-14.09-9.38-21.49-12.91c-7.581-3.62-15.52-6.55-23.61-8.729c-6.44-1.731-12.961-3.241-19.4-4.5
		c-0.54-0.111-0.94-0.191-1.281-0.261c-0.729-0.15-1.239-0.25-2.299-0.42l0.13-0.33c0.71-1.75,0.04-3.55-0.55-5.13
		c-0.09-0.229-0.17-0.46-0.26-0.689l-8.66-20.861c-1.361-3.26-4.09-5.639-7.3-6.35c-4.61-1.01-9.55-1.209-14.341-1.4
		c-1.109-0.04-2.209-0.09-3.289-0.139c-6.1-0.301-12.291-0.431-18.381-0.361c-8.509,0.08-17.299,0.17-26.019,1.45
		c-0.83,0.121-1.66,0.25-2.481,0.38l-0.91,0.14c-1.899,0.301-3.609,1.31-4.84,2.88l-13.059,24.9c-1.06,1.35-1.38,3.09-0.91,4.7
		c-4.72,1.121-11.111,2.8-17.27,4.53c-5.75,1.62-11.55,3.39-17.24,5.26l-0.3,0.1c-5.271,1.74-10.721,3.53-15.771,6.06
		c-11.489,5.74-23.379,15.6-23.379,16.95c-0.05,0.31-1.09,1.95-2.3,3.85c-3,4.71-8.58,13.47-12.681,23.04
		c-3.519,8.22-12.309,40.201-19.359,65.9c-5.05,18.36-9.401,34.221-10.641,37.1c-3.01,7.031-16.01,80.94-17.019,92.09
		c-1,11.031-4.97,39.88-7.991,51.95c-1.679,6.7-3.449,25.661-4.689,41.03v0.011c-0.891,11.12-1.5,20.359-1.59,21.709
		c-0.131,0.11-0.221,0.27-0.23,0.46c-0.02,0.31,0.15,0.581,0.42,0.67c18.65,6.44,31.38,8.17,39.66,8.17c4.24,0,7.31-0.46,9.42-0.96
		c0.599-0.14,1.019-0.67,1.12-1.34h0.02c0.129-0.66,12.379-66.69,15.06-74.169c2.26-6.321,17.399-62.201,19.35-72.941
		c1.549-8.54,6.59-33.09,11.789-47.76c0.061,13.111,0.601,71.39,0.611,72.02l0.889,74.31c-0.009,0.13-1.639,13.49-1.49,20.49
		c0.101,4.41,6.17,8,11.25,10.23c3.5,1.54,7.25,2.54,11.141,2.97l66.99,7.37c0.13,0.01,2.94,0.34,4.66,0.34
		c0.119,0,0.24,0,0.35-0.01c1.16,0.51,6.359,0.86,11.75,0.86c4.55,0,9.22-0.25,11.7-0.87l0.13-0.03l0.07-0.12
		c0.02-0.04,0.039-0.09,0.06-0.14c1.179-0.08,4.809-0.759,4.95-0.78l32.71-3.52c2.88-0.31,5.84-0.57,8.7-0.83
		c7.539-0.67,15.34-1.36,22.85-3.009c0.469-0.111,1-0.221,1.58-0.341c6.99-1.48,20.01-4.22,20.189-12.12
		c0.111-5.02-0.689-13.209-1.17-17.65c-0.219-2-0.359-4.05-0.41-6.09l1.591-72.23v-73.64c3.5,10.03,7.659,27.83,11.79,50.55
		c1.949,10.74,17.08,66.62,19.35,72.941c2.67,7.479,14.929,73.509,15.06,74.169h0.02c0.099,0.67,0.519,1.2,1.12,1.34
		c2.11,0.5,5.18,0.96,9.42,0.96c8.28,0,21.01-1.73,39.66-8.17c0.269-0.089,0.44-0.36,0.42-0.67
		C452.276,447.368,452.186,447.208,452.057,447.098 M303.007,79.389c0.339,0.069,0.75,0.149,1.29,0.259
		c6.42,1.25,12.93,2.76,19.36,4.491c8.05,2.169,15.949,5.089,23.49,8.679c7.36,3.521,14.36,7.72,21.379,12.85
		c1.131,0.83,5.351,3.98,6.471,4.82c0.029,0.021,0.06,0.06,0.09,0.09c-4.85,17.21-8.03,34.311-10.66,51.77
		c-4.45-0.75-50.14-8.24-100.09-6.43l-0.37-13.38c-0.09-3.16-0.17-6.31-0.25-9.46c-0.081-3.08-0.15-6.17-0.23-9.25
		c-0.03-1.42-0.07-2.18-0.101-2.92c-0.03-0.76-0.069-1.519-0.099-2.99c-0.06-2.6-0.11-5.2-0.16-7.8v-1.26c0-3.83,0-10.23-0.12-13.55
		c-0.03-0.919-0.04-1.469-0.05-1.799c5.559,3.819,11.67,9.509,15.92,13.469c2.17,2.031,3.889,3.63,4.91,4.411
		c0.2,0.149,0.47,0.139,0.649-0.041c4.741-4.5,12.321-23,16.151-32.41C301.727,79.128,302.217,79.228,303.007,79.389
		 M264.397,158.018l-0.041-1.45c49.951-1.82,95.641,5.691,99.971,6.43c-0.07,0.46-0.141,0.931-0.21,1.4
		C360.757,163.818,314.977,156.188,264.397,158.018 M350.497,163.048l-0.57,24.18c0,0.26-0.241,0.49-0.55,0.47l-72.83-0.269
		c-0.17,0-0.32-0.061-0.43-0.17c-0.08-0.091-0.13-0.201-0.13-0.321l0.13-28.53C306.897,158.118,334.697,160.988,350.497,163.048
		 M201.417,73.168l13.07-24.9c1.09-1.39,2.65-2.31,4.39-2.589l0.91-0.141c0.819-0.13,1.649-0.26,2.47-0.38
		c8.679-1.28,17.45-1.36,25.94-1.44c6.079-0.06,12.25,0.06,18.34,0.36c1.08,0.05,2.19,0.101,3.3,0.14
		c4.75,0.19,9.67,0.39,14.22,1.39c3.01,0.66,5.56,2.89,6.84,5.96l8.66,20.84c0.079,0.231,0.16,0.45,0.25,0.69
		c0.579,1.541,1.17,3.14,0.56,4.65l-0.16,0.391c-3.7,9.109-11.39,28-16.13,32.649c-1-0.79-2.67-2.34-4.76-4.279
		c-6.471-6.031-17.221-16.051-23.971-17.541c7.241-4.76,18.651-13.57,21.17-18.89c3.661-5.5,9.061-14.52,9.531-16.72
		c0.29-1.33-0.021-2.8-0.81-3.91c-0.601-0.82-1.75-1.859-3.91-2.109l-0.08,0.649c1.519,0.17,2.72,0.81,3.46,1.84
		c0.679,0.95,0.95,2.25,0.71,3.4c-0.41,1.9-5.311,10.26-9.33,16.32c-30.241-3.14-46.08,0.1-48.231,0.591
		c-0.069-0.151-0.17-0.3-0.239-0.431c-4.021-6.04-9.021-14.55-9.431-16.48c-0.25-1.15,0.031-2.45,0.711-3.4
		c0.74-1.03,1.93-1.67,3.449-1.84l-0.07-0.649c-2.159,0.25-3.319,1.289-3.909,2.109c-0.8,1.11-1.101,2.58-0.82,3.91
		c0.479,2.2,5.87,11.21,9.51,16.67c2.549,5.38,13.879,14.13,21.2,18.94c-2.09,0.461-4.571,1.74-7.18,3.47
		c-0.061,0-0.13,0.01-0.19,0.02l0.01,0.1c-5.77,3.84-12.18,9.82-16.61,13.94c-2.09,1.95-3.761,3.511-4.771,4.29
		c-5.519-5.279-17.319-29.94-18.66-32.77C200.096,76.438,200.307,74.598,201.417,73.168 M253.887,92.009
		c-1.17-0.041-2.35-0.08-3.52-0.08c-0.19-0.011-0.37,0-0.56,0c0.03-0.401,0.06-1.061-0.06-1.801c-0.16-0.93-0.35-1.15-0.51-1.25
		l-0.03-0.01c-0.03-0.05-0.06-0.1-0.111-0.13c-6.789-4.41-17.5-12.55-20.91-18.01c2.691-0.589,18.311-3.56,47.531-0.56
		c-2.89,5.35-14.04,13.9-21.031,18.45c-0.09,0.061-0.149,0.141-0.189,0.23l-0.05,0.03c-0.16,0.1-0.351,0.32-0.5,1.25
		C253.807,90.918,253.846,91.618,253.887,92.009 M249.106,90.238c0.111,0.71,0.08,1.351,0.041,1.691h-0.16
		c-1.77,0.029-4.26,0.149-6.461,0.349c2.351-1.46,4.561-2.49,6.391-2.78C248.957,89.598,249.026,89.808,249.106,90.238
		 M249.016,89.458c0.031-0.02,0.071-0.029,0.101-0.05l0.01,0.04C249.087,89.468,249.057,89.458,249.016,89.458 M254.727,89.458
		c-0.05,0.01-0.11,0.02-0.17-0.01l0.03-0.09C254.627,89.398,254.677,89.429,254.727,89.458 M254.587,90.238
		c0.07-0.46,0.15-0.67,0.189-0.76c0.041,0.02,0.061,0.05,0.101,0.06c1.79,0.32,3.92,1.33,6.18,2.73c-0.281-0.02-0.56-0.03-0.9-0.03
		c-1.29-0.04-2.57-0.09-3.86-0.14c-0.58-0.03-1.17-0.05-1.75-0.07C254.507,91.718,254.457,91.018,254.587,90.238 M149.677,94.048
		c5.009-2.51,10.44-4.289,15.679-6.02l0.301-0.099c5.689-1.871,11.479-3.641,17.22-5.25c6.18-1.741,12.6-3.42,17.32-4.54
		c0.03,0.049,0.04,0.109,0.069,0.159c1.361,2.881,13.491,28.2,19.01,33.16l0.201,0.181l0.209-0.161c1.011-0.74,2.791-2.4,5.041-4.5
		c3.28-3.06,7.67-7.139,12.039-10.6l-0.009,2.67c-0.071,10.32-0.13,20.07,0.29,30.76l0.229,5.88c0.261,6.66,0.521,13.451,0.75,20.26
		c-50.409-1.87-97.099,5.7-101.019,6.35c-2.47-17.409-5.55-34.89-10.34-51.869C127.157,109.188,137.997,99.889,149.677,94.048
		 M137.307,164.389c-0.07-0.481-0.14-0.96-0.201-1.441c3.78-0.64,50.5-8.24,100.951-6.35c0.01,0.48,0.03,0.96,0.039,1.45
		C187.886,156.179,141.587,163.679,137.307,164.389 M225.887,158.418l0.959,27.66c0,0.14-0.07,0.25-0.129,0.311
		c-0.1,0.109-0.26,0.179-0.43,0.179l-72.91,1.5c-0.281,0-0.531-0.2-0.54-0.46l-1.061-24.64
		C167.897,160.908,195.567,158.139,225.887,158.418 M98.856,454.808c-6.159,1.47-20.67,2.49-48.659-7.219
		c5.72-1.151,25.76-4.08,48.76,5.289c0.44,0.19,0.569,0.68,0.54,1.051C99.477,454.288,99.287,454.708,98.856,454.808
		 M99.747,452.708c-0.151-0.18-0.33-0.34-0.55-0.43c-22.74-9.269-42.62-6.59-48.8-5.389c0.129-1.971,0.709-10.601,1.539-20.96
		c2.181-0.381,11.261-1.861,18.75-1.461c0.191,0,19.34,0.47,32.791,8.461C101.717,442.158,100.297,449.728,99.747,452.708
		 M133.917,306.868c-1.95,10.721-17.061,66.53-19.321,72.84c-1.71,4.78-7.129,32.36-10.99,52.551
		c-13.59-7.971-32.709-8.441-32.899-8.441c-7.37-0.389-16.26,1.021-18.72,1.441c1.24-15.311,3-34.111,4.66-40.75
		c3.02-12.101,7-41,8.01-52.051c1.01-11.14,13.97-84.89,16.97-91.9c1.25-2.919,5.61-18.799,10.66-37.18
		c7.059-25.68,15.84-57.64,19.34-65.82c4.08-9.51,9.639-18.25,12.62-22.94c1.029-1.609,1.65-2.6,2.01-3.22
		c7.05,25.27,10.36,51.7,13.55,77.27c1.06,8.49,2.15,17.261,3.37,25.9c1.98,14.03,3.169,30.021,3.169,42.78
		C140.907,271.798,135.537,297.988,133.917,306.868 M235.807,445.968l-66.99-7.37c-3.82-0.419-7.51-1.4-10.95-2.91
		c-4.91-2.16-10.771-5.58-10.86-9.65c-0.151-6.949,1.47-20.27,1.49-20.44l-0.891-74.36c-0.01-0.66-0.609-65.92-0.609-73.83
		c0-12.81-1.19-28.86-3.17-42.94c-1.221-8.62-2.32-17.4-3.38-25.879c-0.97-7.791-1.95-15.66-3.05-23.551
		c1.22-0.21,6.119-1.01,13.73-1.99l1.059,24.591c0.021,0.599,0.551,1.079,1.181,1.079h0.03l72.9-1.5
		c0.34-0.01,0.67-0.15,0.889-0.379c0.211-0.221,0.321-0.5,0.311-0.791l-0.96-27.619c3.83,0.039,7.69,0.119,11.58,0.269
		c0.17,5.02,0.319,10.04,0.43,15.03c0.13,5.64,0.219,10.84,0.28,15.88c0.17,16.22,0.48,64.96,0.76,107.96
		c0.259,40.91,0.49,76.24,0.56,80.29c0.17,8.49-0.34,59.87-0.82,65.071c-0.02,0.099-0.33,2.129,0.63,3.369
		C238.257,446.259,235.846,445.968,235.807,445.968 M263.897,446.339c-5.67,1.359-21.5,0.8-22.93,0c-1.39-0.771-1-3.281-1-3.33
		c0.49-5.231,1-56.661,0.83-65.161c-0.08-4.04-0.31-41.08-0.56-80.28c-0.28-43-0.59-91.74-0.76-107.97
		c-0.06-5.04-0.15-10.24-0.27-15.88c-0.29-12.7-0.8-25.59-1.28-38.05l-0.23-5.89c-0.421-10.67-0.36-20.41-0.29-30.72l0.02-3.19
		c1.31-1.01,2.61-1.96,3.88-2.81c2.42-0.28,5.64-0.45,7.69-0.48h0.34c0.349,0,0.689-0.01,1.03,0c1.97,0.011,3.97,0.09,5.899,0.17
		c1.291,0.05,2.58,0.1,3.881,0.141c0.77,0.009,1.22,0.029,2.119,0.149c0.021,0.01,0.031,0.02,0.041,0.03c0,0.191,0,0.74,0.049,2.26
		c0.131,3.311,0.121,9.71,0.121,13.53v1.27c0.049,2.6,0.1,5.2,0.159,7.801c0.031,1.479,0.071,2.239,0.101,3.009
		c0.039,0.741,0.07,1.491,0.1,2.91c0.08,3.081,0.15,6.161,0.23,9.25c0.08,3.15,0.16,6.3,0.25,9.45l0.43,15.49h-0.02l0.02,0.66
		c0.01-0.01,0.01-0.01,0.019-0.01l0.741,26.79l-0.1,257.02C264.407,442.518,264.846,444.639,263.897,446.339 M354.797,254.578v75.49
		l-1.59,72.24c0.05,2.07,0.19,4.15,0.41,6.16c0.489,4.421,1.28,12.58,1.17,17.57c-0.16,7.38-12.86,10.06-19.681,11.49
		c-0.569,0.12-1.109,0.24-1.58,0.34c-7.469,1.65-15.25,2.34-22.76,3c-2.869,0.26-5.83,0.521-8.719,0.83l-32.73,3.52
		c-1.221,0.23-3.44,0.63-4.541,0.75c0.641-1.73,0.281-3.51,0.271-3.539l0.11-256.961l-0.74-26.8c3.71-0.13,7.4-0.22,11.05-0.26
		l-0.13,28.53c0,0.29,0.11,0.56,0.32,0.78c0.229,0.23,0.55,0.36,0.89,0.36l72.83,0.28h0.009c0.64,0,1.181-0.5,1.191-1.12
		l0.57-24.099c7.32,0.959,11.93,1.739,12.879,1.899c-1.319,8.971-2.519,18.051-3.729,27.29c-0.93,7.03-1.88,14.29-2.9,21.48
		C355.677,226.048,354.797,239.768,354.797,254.578 M387.197,379.708c-2.261-6.31-17.37-62.119-19.32-72.83
		c-4.38-24.09-8.79-42.67-12.43-52.35c0-14.76,0.88-28.43,2.6-40.63c1.01-7.19,1.969-14.46,2.889-21.48
		c3.67-27.96,7.151-54.38,14.601-81.029c0.39,0.7,1.08,1.779,2,3.229c2.989,4.69,8.55,13.42,12.63,22.94
		c3.5,8.18,12.28,40.14,19.33,65.82c5.05,18.381,9.42,34.261,10.67,37.18c3,7.01,15.96,80.76,16.969,91.9
		c1.011,11.051,4.991,39.95,8.011,52.051c1.66,6.649,3.42,25.469,4.66,40.789c-2.121-0.369-11.31-1.88-18.921-1.48
		c-0.189,0-19.149,0.47-32.719,8.33C394.307,411.978,388.907,384.488,387.197,379.708 M398.297,432.818
		c13.43-7.88,32.41-8.35,32.61-8.36c7.77-0.4,17.229,1.2,18.949,1.51c0.83,10.34,1.401,18.95,1.53,20.921
		c-6.169-1.201-26.049-3.88-48.79,5.389c-0.219,0.09-0.399,0.25-0.549,0.43C401.487,449.718,400.067,442.098,398.297,432.818
		 M451.657,447.618c-28.04,9.68-42.561,8.66-48.721,7.19c-0.429-0.1-0.619-0.52-0.649-0.879c-0.021-0.371,0.099-0.861,0.55-1.051
		c12.91-5.26,24.88-6.64,33.92-6.64c7.12,0,12.41,0.86,14.9,1.36V447.618z"
        />
        <path
          fill="#010101"
          d="M229.477,324.668c-35.18-0.871-49.75-3.31-57.57-4.621c-0.651-0.099-1.24-0.199-1.79-0.289
		c-3.481-0.56-10.13-2.01-10.21-2.03l-4.441-0.78c-0.21-0.04-0.429,0.019-0.589,0.16c-0.17,0.14-0.26,0.34-0.26,0.56v25.03
		c0,0.49,0.26,0.96,0.69,1.21c0.459,0.28,0.85,0.5,1.219,0.69h-0.159l0.45,61.23v0.17l0.14,0.1c2.24,1.55,4.69,2.83,7.299,3.8
		c2.641,0.98,5.231,1.49,8.1,2c5.871,1.06,11.851,1.95,17.761,2.66c9.8,1.18,19.8,2.15,29.47,3.07c2.72,0.27,5.439,0.53,8.169,0.79
		c0.041,0.01,0.081,0.01,0.121,0.01c0.33,0,0.649-0.12,0.889-0.34c0.271-0.25,0.431-0.6,0.431-0.97v-64.7
		c0.04,0,0.09,0.01,0.13,0.01h0.029c0.28,0,0.551-0.11,0.75-0.31c0.211-0.2,0.32-0.47,0.32-0.76v-25.71
		C230.426,325.118,229.997,324.688,229.477,324.668 M228.547,417.118c0,0.19-0.081,0.36-0.22,0.49
		c-0.141,0.12-0.321,0.189-0.51,0.17c-2.721-0.27-5.44-0.53-8.17-0.79c-9.66-0.93-19.66-1.89-29.45-3.07
		c-5.9-0.71-11.87-1.61-17.731-2.66c-2.839-0.51-5.399-1.01-7.989-1.97c-2.5-0.93-4.86-2.15-7.02-3.63l-0.441-60.81
		c0.601,0.3,1.17,0.55,1.891,0.86c3,1.28,6.279,2.55,9.939,3.15c10.01,1.609,30.101,2.81,59.701,3.55V417.118z M229.776,351.358
		c0,0.109-0.039,0.21-0.119,0.29c-0.09,0.09-0.191,0.12-0.311,0.13c-30.009-0.74-50.32-1.94-60.389-3.57
		c-3.601-0.58-6.83-1.83-9.79-3.1c-1.3-0.561-2.09-0.9-3.531-1.75c-0.229-0.141-0.37-0.391-0.37-0.66v-25.03l0.09-0.08l4.431,0.78
		c0.069,0.02,6.729,1.47,10.219,2.03c0.551,0.09,1.151,0.19,1.791,0.3c7.839,1.31,22.43,3.75,57.66,4.62
		c0.179,0.01,0.319,0.149,0.319,0.33V351.358z"
        />
        <path
          fill="#010101"
          d="M349.717,317.108c-0.17-0.14-0.38-0.2-0.6-0.16l-4.45,0.79c-0.07,0.01-6.72,1.46-10.19,2.021
		c-0.55,0.089-1.14,0.189-1.791,0.289c-7.819,1.31-22.389,3.75-57.569,4.62c-0.53,0.02-0.96,0.45-0.96,0.98v25.71
		c0,0.29,0.119,0.56,0.33,0.76c0.199,0.2,0.47,0.31,0.75,0.31h0.029c0.041,0,0.081-0.01,0.131-0.01v64.7
		c0,0.37,0.15,0.721,0.43,0.971c0.24,0.219,0.56,0.339,0.89,0.339c0.04,0,0.08,0,0.12-0.01c2.73-0.26,5.45-0.52,8.179-0.79
		c9.661-0.93,19.661-1.89,29.461-3.07c5.92-0.71,11.89-1.61,17.76-2.66c2.869-0.51,5.46-1.02,8.1-2c2.61-0.97,5.06-2.25,7.3-3.8
		l0.139-0.1l0.451-61.4h-0.16c0.369-0.19,0.76-0.41,1.22-0.69c0.43-0.25,0.69-0.72,0.69-1.21v-25.03
		C349.977,317.448,349.887,317.248,349.717,317.108 M347.127,405.658c-2.15,1.48-4.51,2.7-7.01,3.63
		c-2.601,0.96-5.16,1.46-7.99,1.971c-5.861,1.049-11.82,1.949-17.73,2.659c-9.791,1.18-19.78,2.14-29.45,3.07
		c-2.72,0.26-5.45,0.521-8.171,0.79c-0.189,0.01-0.379-0.05-0.519-0.17c-0.13-0.13-0.21-0.3-0.21-0.49v-64.71
		c29.6-0.74,49.69-1.94,59.69-3.55c3.67-0.599,6.949-1.87,9.949-3.15c0.721-0.31,1.281-0.56,1.891-0.86L347.127,405.658z
		 M349.327,342.698c0,0.27-0.141,0.52-0.37,0.66c-1.441,0.85-2.23,1.19-3.53,1.75c-2.96,1.27-6.19,2.52-9.79,3.1
		c-10.07,1.631-30.39,2.83-60.39,3.57c-0.09,0-0.231-0.04-0.311-0.13c-0.08-0.08-0.129-0.18-0.129-0.29v-25.71
		c0-0.18,0.15-0.32,0.33-0.33c35.219-0.87,49.82-3.309,57.66-4.62c0.639-0.109,1.229-0.21,1.78-0.3c3.5-0.559,10.16-2.01,10.22-2.03
		l4.44-0.779l-0.06-0.321l0.15,0.4V342.698z"
        />
      </g>
    </svg>
  );
}
